import React from 'react';

import CVDocument from '../document.component';
import { CVSubnav } from '../shell.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/get-started.en';

// Get started: the first session, step by step. The page itself is written out
// once per language in locales/.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/get-started.${code}`));

const CaptiVisionGetStarted = () => {
    const [page, lang] = useLocalizedPage(PAGES);

    return (
        <CVDocument
            lang={lang}
            title={page?.title}
            eyebrow={page?.eyebrow}
            lede={page?.lede}
            subnav={<CVSubnav current="get-started" />}
            navCurrent="User guide"
            footerCurrent="Get started">
            {page?.body}
        </CVDocument>
    )
}

export default CaptiVisionGetStarted;
